import * as React from 'react';

function SvgWatch(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8.5 5a.5.5 0 00-1 0v2.5H6a.5.5 0 000 1h2a.5.5 0 00.5-.5V5z' />
			<path d='M5.667 16C4.747 16 4 15.254 4 14.333v-1.86A5.985 5.985 0 012 8c0-1.777.772-3.374 2-4.472V1.667C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v1.86a5.99 5.99 0 011.918 3.48.502.502 0 01.582.493v1a.5.5 0 01-.582.493A5.99 5.99 0 0112 12.473v1.86c0 .92-.746 1.667-1.667 1.667H5.667zM13 8A5 5 0 103 8a5 5 0 0010 0z' />
		</svg>
	);
}

export default SvgWatch;
